if (!customElements.get('wls-custom-select-dropdown-sort')) {
  class WLSCustomSelectDropdownSort extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        selectBox: 'js-select-box',
        selectPlaceholder: 'js-select-placeholder',
        selectButton: 'js-select-button',
        optionsList: 'js-select-options',
        options: 'js-select-option',
      };

      this.selectors = {
        selectBox: this.querySelector(`.${this.classes.selectBox}`),
        selectPlaceholder: this.querySelector(`.${this.classes.selectPlaceholder}`),
        selectButton: this.querySelector(`.${this.classes.selectButton}`),
        optionsList: this.querySelector(`.${this.classes.optionsList}`),
        options: this.querySelectorAll(`.${this.classes.options}`),
      };
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     *
     * @returns {void}
     */
    connectedCallback() {
      this.init();
    }

    /**
     * Initializes event listeners for the select dropdown.
     * If required elements are missing, the initialization is skipped.
     */
    init() {
      if (!this.selectors.selectBox || !this.selectors.optionsList) return;

      this.selectors.selectBox.addEventListener('click', (e) => {
        e.stopPropagation();
        this.toggleDropdown();
      });

      this.selectors.options.forEach((option) => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();
          this.selectOption(e.currentTarget);
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.selectors.selectBox.contains(e.target)) this.closeDropdown();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeDropdown();
      });
    }

    /**
     * Toggles the dropdown menu visibility.
     */
    toggleDropdown() {
      const isActive = this.selectors.optionsList.classList.toggle(this.classes.active);
      this.selectors.selectBox.setAttribute('aria-expanded', isActive);
      this.selectors.optionsList.setAttribute('aria-hidden', !isActive);
    }

    /**
     * Handles the selection of an option from the dropdown.
     * Updates the placeholder text and closes the dropdown.
     *
     * @param {HTMLElement} option - The selected dropdown option.
     */
    selectOption(option) {
      const selectedValue = option.getAttribute('data-value');
      this.updatePlaceholder(selectedValue);
      this.closeDropdown();
      this.selectors.options.forEach((opt) => {
        opt.setAttribute('aria-selected', 'false');
        opt.classList.remove(this.classes.active);
      });
      option.setAttribute('aria-selected', 'true');
      option.classList.add(this.classes.active);
    }

    /**
     * Closes the dropdown menu and removes active classes.
     */
    closeDropdown() {
      this.selectors.optionsList.classList.remove(this.classes.active);
      this.selectors.selectBox.setAttribute('aria-expanded', 'false');
      this.selectors.optionsList.setAttribute('aria-hidden', 'true');
    }

    /**
     * Update the dropdown menu placeholder.
     */
    updatePlaceholder(selectedValue) {
      this.selectors.selectPlaceholder.textContent = selectedValue;
    }
  }

  window.customElements.define('wls-custom-select-dropdown-sort', WLSCustomSelectDropdownSort);
}
